export var STATUS_INDICATOR_GAP = 8;
export var STATUS_INDICATOR_MIN_WIDTH = 112;